const d3 = Object.assign(
    {},
    require("d3-array"),
    require("d3-selection"),
    require("d3-fetch"),
    require("d3-transition"),
    require("d3-ease"),
    require("d3-scale"),
    require("d3-color")
)

import prepareData from "./d3-color-data"
import drawBase from "./d3-color-drawBase"
import { drawContent, draw, drawHighlight, hideToolTip } from "./d3-color-drawContent"
import getDimensions from "./d3-color-dimenions"

export default class ColorViz {
    constructor(DOMtarget) {
        this.DOMtarget = DOMtarget
        this.dataset = null
        this.objArray = []

        this.context = null // Canvas Context
        this.canvas = null // Canvas Object
        this.contextVoronoi = null
        this.canvasVoronoi = null

        // initiale scale
        this.transform = {}
        this.transform.x = 0
        this.transform.y = 0
        this.scale = 1
      
        this.dimensions = null
        this.colorSource = null

        // Data
        if (localStorage.getItem("d3_color") === null) {
        } else {
            let locStorage = JSON.parse(localStorage.getItem("d3_color"))
        }

        // Accessors
        ;(this.colorAccessor = d => this.getValuefromHex(d.color, "l")),
        // Scales
        (this.scaleColor = null)

        // Transitions
    }

    async loadData(fileName) {
        const theDataSet = await d3.json(`/data/${fileName}.json`)
        console.log(`This dataset contains ${theDataSet.length} photos`)
        this.dataset = theDataSet
        return theDataSet
    }

    init() {
        this.dimensions = getDimensions(this.DOMtarget)

        if (localStorage.getItem("d3_color") === null) {
            const locStorage = {}
            window.localStorage.setItem("d3_color", JSON.stringify(locStorage))
        }

        this.initScales()
        this.prepareData()
    }

    initScales() {
        this.scaleColor = d3
            .scaleLinear()
            .domain(d3.extent(this.dataset, this.colorAccessor))
            .range([0.1, 0.9]) // offset
    }

    getValuefromHex(color, value) {
        const hsl = d3.hsl(color)
        return hsl[value]
    }

    getCoordinatesFromColor(color, offset = 1) {
        const hsl = d3.hsl(color)
        if (isNaN(hsl.h)) {
            hsl.h = 0
        }

        return this.getCoordinatesForAngle(hsl.h, offset)
    }

    getCoordinatesForAngle(angle, offset = 1) {
        angle = (angle * Math.PI) / 180

        let hShift, vShift
        hShift = this.dimensions.boundedRadius + this.dimensions.margin.left
        vShift = this.dimensions.boundedRadius + this.dimensions.margin.top

        const totalWidth =
            this.dimensions.boundedRadius * 2 +
            this.dimensions.margin.left +
            this.dimensions.margin.right
        const totalHeight =
            this.dimensions.boundedRadius * 2 +
            this.dimensions.margin.top +
            this.dimensions.margin.bottom

        if (this.dimensions.width > this.dimensions.height) {
            //     // Center circle for HORIZONTAL
            hShift += (this.dimensions.width - totalWidth) / 2
        } else {
            //     // Center circle for VERTICAL
            vShift += (this.dimensions.height - totalHeight) / 2
        }
        // rounding required for delaunay problem: https://github.com/d3/d3-delaunay/issues/79
        return [
            Math.round(Math.cos(angle - Math.PI / 2) *
                this.dimensions.boundedRadius *
                offset +
                hShift),
            Math.round(Math.sin(angle - Math.PI / 2) *
                this.dimensions.boundedRadius *
                offset +
                vShift)
        ]
    }

    getColor(datum, colorSource) {
        switch (colorSource) {
        // Ruturn the value that returns the color value
        case 1:
            return datum.color
        case 2:
            if (typeof datum.colors.main != "undefined") {
                return `rgb(${datum.colors.main[0][0]}, ${
                    datum.colors.main[0][1]
                }, ${datum.colors.main[0][2]})`
            } else {
                return "#FF0000"
            }

        case 3:
            if (typeof datum.colors.palette != "undefined") {
                return `rgb(${datum.colors.palette[0][0]}, ${
                    datum.colors.palette[0][1]
                }, ${datum.colors.palette[0][2]})`
            } else {
                return "#FF0000"
            }
        }
    }

    rgbColorGenerator(index = 1) {

        const colorstep = 271
        const nextColor = index*colorstep
        if (nextColor < 16777216) {
            const rgb = []
            rgb.push(nextColor & 0xff) // R.
            rgb.push((nextColor & 0xff00) >> 8) // G.
            rgb.push((nextColor & 0xff0000) >> 16) // B.

            return rgb
        } else {
            return "Color out of scope"
        }
    }

    redraw() {
        d3.select(`#canvasVoronoi`).remove()
        d3.select(`#canvas`).remove()
        this.hideToolTip()
        this.init()
        this.drawBase()
        this.drawContent()
    }
}

Object.assign(ColorViz.prototype, {
    drawBase,
    drawContent,
    draw,
    drawHighlight,
    hideToolTip,
    prepareData
})
